import Footer from "./Component/Footer";
import Grid from "./Component/Grid";
import Me from "./Component/Me";
import Navbar from "./Component/Navbar";


function App() {
  return (
    <div>
      <Navbar />
      <Me />
      <Grid />
      <Footer />
    </div>
  );
}

export default App;
